import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Battery } from 'lucide-react';
import { formatDistanceToNow, parseISO } from 'date-fns';

interface BatteryHealthCardProps {
  capacityKwh: number;
  degradationPct: number;
  cycles: number | null;
  snapshotAt: string;
}

function gradeFromDegradation(pct: number): { grade: string; color: string } {
  if (pct < 5) return { grade: 'A', color: 'text-wt-green-primary' };
  if (pct < 10) return { grade: 'B', color: 'text-wt-green-primary' };
  if (pct < 15) return { grade: 'C', color: 'text-wt-amber-primary' };
  return { grade: 'D', color: 'text-wt-red-primary' };
}

export function BatteryHealthCard({ capacityKwh, degradationPct, cycles, snapshotAt }: BatteryHealthCardProps) {
  const { grade, color } = gradeFromDegradation(degradationPct);

  return (
    <Card className="bg-wt-bg-secondary border-border">
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-medium text-muted-foreground flex items-center gap-2">
          <Battery className="w-4 h-4" />
          Battery Health
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="flex items-baseline gap-3">
          <span className={`font-mono text-3xl font-bold ${color}`}>{grade}</span>
          <span className="text-sm text-muted-foreground">health grade</span>
        </div>

        <div className="grid grid-cols-2 gap-4 text-sm">
          <div>
            <p className="text-muted-foreground">Capacity</p>
            <p className="font-mono font-medium">{capacityKwh.toFixed(1)} kWh</p>
          </div>
          <div>
            <p className="text-muted-foreground">Degradation</p>
            <p className="font-mono font-medium">{degradationPct.toFixed(1)}%</p>
          </div>
          {cycles != null && (
            <div>
              <p className="text-muted-foreground">Cycles</p>
              <p className="font-mono font-medium">{cycles.toFixed(0)}</p>
            </div>
          )}
        </div>

        <p className="text-xs text-muted-foreground">
          Last assessed {formatDistanceToNow(parseISO(snapshotAt))} ago
        </p>
      </CardContent>
    </Card>
  );
}
